export enum ShotStatusEnum {
  NotUploaded = 1,
  Uploaded = 2,
  Approved = 3,
  Rejected = 4
}
